import { showNotification } from '@mantine/notifications'
import type { BookSurveyVisitAuthenticated } from '@markku/types'
import { trpc } from '../trpc'

export const visitHooks = {
  useBookSurveyVisit: () => {
    return trpc.visit.bookSurveyVisitAuthenticated.useMutation({
      onSuccess: () => {
        showNotification({
          title: 'Varaus onnistui',
          message: 'Kartoituskäynti on varattu onnistuneesti',
          color: 'green',
        })
      },
      onError: (error) => {
        showNotification({
          title: 'Virhe varauksessa',
          message: error.message || 'Kartoituskäynnin varaus epäonnistui',
          color: 'red',
        })
      },
    })
  },

  useGetAvailableTimeSlots: () => {
    return trpc.visit.getAvailableTimeSlots.useQuery({})
  },

  useList: () => {
    return trpc.visit.list.useQuery({})
  },

  useGetById: (id?: number) => {
    return trpc.visit.getById.useQuery(
      { id: id! },
      {
        enabled: id !== undefined,
      },
    )
  },
}

export type BookSurveyVisitInput = BookSurveyVisitAuthenticated
